const initialState = {
  data: ''
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'FEATURE_SUCCESS':
      return {
        ...state, 
        data: action.data, 
      };
    case 'FEATURE_OUT':
      return state;
    default:
      return state;
  }
}
